// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a9115acb","239":"88b35ced","732":"0aaec78d"}[chunkId] + ".chunk.js";
};